<template>
    <GeneralModal :show-modal="isShowModal" :additional-modal-style="['popup']" :key-up-event="closeModal">
        <template #header>
            <button class="popup__close-btn" @click="closeModal" />
        </template>
        <template #body>
            <article class="popup__char">
                <header class="popup__char-title">
                    <h3 class="popup__char-name">{{ $t('dialog.kartrider.tittle') }}</h3>
                </header>
                <p class="popup__char-description">
                    {{ $t('dialog.kartrider.body') }}
                </p>
                <p class="popup__char-description">
                    {{ $t('dialog.kartrider.footer') }}
                </p>
            </article>
        </template>
    </GeneralModal>
</template>

<script>
import GeneralModal from '@/components/dialogs/general-modal';

export default {
    name: 'KeepProgress',
    components: {
        GeneralModal,
    },
    props: {
        isInitialShowModal: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isShowModal: false,
        };
    },
    mounted() {
        if (this.isInitialShowModal) {
            this.isShowModal = true;
        }
    },
    methods: {
        closeModal() {
            this.isShowModal = false;
        },
    },
};
</script>

<style lang="less" scoped>
::v-deep .popup {
    width: 100%;
    max-width: 400px;
    min-height: 300px;
    border: 2px solid #1e88e5;
    border-radius: 20px;
    margin-top: calc(50vh - 14.75rem);
    background-color: rgba(255, 255, 255, 0);
    background-image: url('~@/images/kd-modal-bg.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    box-sizing: border-box;
    overflow: hidden;
    color: #ffffff;
    padding: 0;

    .g-modal-header {
        display: flex;
        justify-content: flex-end;
        padding-top: 10px;
        margin-right: 10px;
        box-sizing: border-box;
    }

    &__close-btn {
        width: 20px;
        height: 20px;
        background-image: url('~@/images/kd-modal-close.png');
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
        position: absolute;
        top: 8px;
        right: 8px;
        &:hover {
            background-image: url('~@/images/kd-modal-close-hover.png');
        }
    }

    &__char {
        padding: 140px 14px 20px 14px;
        &-name {
            font-family: 'Arial Bold', 'Arial', sans-serif;
            font-weight: 700;
            color: #ffffff;
            text-align: center;
            line-height: normal;
            font-size: 20px;
            margin-bottom: 10px;
        }

        &-description {
            font-family: 'Arial', sans-serif;
            color: #ffffff;
            text-align: center;
            line-height: normal;
            font-size: 14px;
            margin-bottom: 15px;
        }
    }
}
</style>
